<template>
  <div id="app">
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Footer from './common/Footer';

const PUBLIC_ROUTES = ['/login', '/register', '/language'];

export default {
  name: 'app',
  components: {
    Footer,
  },
  computed: {
    brandName() {
      const baseInfo = this.$store.getters.getBaseInfo || {};
      return baseInfo.name || '';
    },
    routeTitle() {
      const matched = this.$route.matched && this.$route.matched[0];
      const titleKey = matched && matched.meta && matched.meta.titleKey;
      return titleKey ? this.$t(titleKey) : '';
    },
  },
  data() {
    return {
      baseInfoLoaded: false,
    };
  },
  methods: {
    hasToken() {
      return Boolean(localStorage.getItem('token'));
    },
    isPublicRoute(path) {
      const target = (path || '').toLowerCase();
      return PUBLIC_ROUTES.includes(target);
    },
    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info',
      }).then((res) => {
        if (!res.ok) {
          if (res.code === 401 || res.code === 403) {
            this.handleUnauthorized();
          }
          return;
        }
        if (res.data) {
          this.$store.commit('setBaseInfoValue', res.data);
          this.baseInfoLoaded = true;
          this.updateDocumentTitle();
        }
      });
    },
    updateDocumentTitle() {
      const titleParts = [this.brandName, this.routeTitle].filter(Boolean);
      document.title = titleParts.join(' - ') || this.$t('routes.home');
    },
    handleUnauthorized() {
      this.baseInfoLoaded = false;
      localStorage.removeItem('token');
      if (!this.isPublicRoute(this.$route.path)) {
        this.$router.replace({ path: '/Login' });
      }
    },
    guardRoute() {
      if (!this.hasToken() && !this.isPublicRoute(this.$route.path)) {
        this.$router.replace({ path: '/Login' });
        return;
      }
      if (!this.baseInfoLoaded) {
        this.getBaseInfo();
      }
    },
  },
  created() {
    this.getBaseInfo();
    this.guardRoute();
    this.updateDocumentTitle();
  },
  watch: {
    $route() {
      this.guardRoute();
      this.updateDocumentTitle();
    },
    brandName() {
      this.updateDocumentTitle();
    },
    '$i18n.locale'() {
      this.updateDocumentTitle();
    },
  },
};
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 230px;
  background: linear-gradient(30deg, #d51aac, #d63f8c) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
